export default "/_next/static/images/78e29d3aad4ecbd8d556c84301c69a7e.jpg";